import { defineComponent as _defineComponent } from 'vue'
import { computed, withDefaults } from 'vue';
import { BARRIER_ACCESS_TYPES } from '@white-label-configuration/constants';
import { imgErrorComposable } from '@white-label-helper/img-error-composable';
import type { EntryMethod, InventoryItem } from '@white-label-types/parking-booking';

// Components
import ToggleContent from '../toggle-content/toggle-content.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-directions-information',
  props: {
    inventoryItem: null,
    barrierAccess: { default: () => {} }
  },
  setup(__props: any) {

const props = __props as { inventoryItem: InventoryItem, barrierAccess: EntryMethod['entryMethod'] };



const { imgError, imgNotLoading } = imgErrorComposable();

const arrivalInfo = computed((): string => {
  return props.inventoryItem.entrance_info;
});
const departureInfo = computed((): string => {
  return props.inventoryItem.exit_info;
});
const displayMap = computed((): boolean => {
  return props.inventoryItem.map_image?.src;
});
const displayAirportInformation = computed((): boolean => {
  return !!arrivalInfo.value || !!departureInfo.value || !!displayMap.value;
});
const additionalInfoExpanded = computed((): boolean => {
  return props.barrierAccess?.type === BARRIER_ACCESS_TYPES.NONE;
});

return { __sfc: true,props, imgError, imgNotLoading, arrivalInfo, departureInfo, displayMap, displayAirportInformation, additionalInfoExpanded, ToggleContent }
}

})